// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GQvT6","badges":"styles_badges__3_hK7"};